import React from 'react';

import PageLayout from '../../../components/PageLayout';

import Team from './Team';

async function action() {
  return {
    title: 'Team',
    description:
      "Learn about how Flux Tech came to be and why we're the company that we are today",
    chunks: ['team'],
    component: (
      <PageLayout>
        <Team />
      </PageLayout>
    ),
  };
}

export default action;
